export const LOAD_COURSE_ACTIVITY_USER_LIST = '@COURSE_ACTIVITY/LOAD_COURSE_ACTIVITY_USER_LIST'
export const LOAD_STUDY_COURSE_TIME = '@COURSE_ACTIVITY/LOAD_STUDY_COURSE_TIME'
export const LOAD_STUDY_COURSE_HISTORY = '@COURSE_ACTIVITY/LOAD_STUDY_COURSE_HISTORY'
export const LOAD_COURSE_RANKING_ALL = '@COURSE_ACTIVITY/LOAD_COURSE_RANKING_ALL'
export const LOAD_COURSE_RANKING_NISSOKEN = '@COURSE_ACTIVITY/LOAD_COURSE_RANKING_NISSOKEN'
export const LOAD_COURSE_RANKING_COMPANY = '@COURSE_ACTIVITY/LOAD_COURSE_RANKING_COMPANY'
export const UPDATE_BOOKMARK = '@COURSE_ACTIVITY/UPDATE_BOOKMARK'
